<script>
	import Warning from './../icons/Warning.svelte';
    import { fade } from 'svelte/transition';
    import { notInPreview } from '../store';

    //todo add translations
notInPreview
</script>

<div class="modal" transition:fade>
    <div id="notify-view">
        <div id="notify-content" class="model-content">
            <Warning/>
            <p>To see all features and screens, please publish your app when it is completed.</p>
            <div class="notify-button user-color-background close" on:click="{()=> notInPreview.set(false)}">CLOSE</div>
        </div>
    </div>
</div>

<style>
.modal{
    position:absolute;
    top: 0;
    left:0;
    min-width: 100%;
    min-height: 100%;
    z-index: 9999;
    background: rgba(0,0,0,.5);
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
}
.model-content{
    max-width: 600px;
    background-color: #fff;
    min-height: 300px;
    border-radius: 12px;
    width:calc(100% - 40px);
    margin: 20px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    flex-flow: row;
    flex-wrap: wrap;
}

.model-content p{
    min-width: 100%;
    text-align: center;
}
.notify-button {
    color: #fff;
    border-radius: 12px;
    min-width: 100px;
    padding: 10px;
    margin: 5px;
    text-align: center;
    display: block;
    width: 80%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}


</style>